    <template>
  <client-only>
    <v-row class="primary--text company-join-box pt-0 px-0" relaive id="company-join-board">
      <v-col class="pb-0">
        <v-row class="flex-column company-join-details" v-if="benefits">
          <v-col class="px-5">
            <h3
              class="display-36-24"
              :class="[isMobile ? 'text-center' : 'text-right']"
            >{{textForTitle}}</h3>
          </v-col>
          <div class="icons-container">
            <img src="@/assets/img/icon-big-ok.png" :alt="companyName" class="icon-big-ok"/>
            <img src="@/assets/img/icon-star.png" :alt="companyName" class="icon-star"/>
            <img src="@/assets/img/icon-ok.png" :alt="companyName" class="icon-ok"/>
          </div>
          <v-col class="py-0 px-5">
            <v-row class="px-4">
              <v-col>
                <CompanyGooddies :benefits="benefits" :CustomBenefit="CustomBenefit" :name="companyName" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </client-only>
</template>

<script>
import { isEmpty } from 'lodash'

import CompanyGooddies from '@/components/Company/CompanyGooddies'
//import WorkersSayings from '@/components/Company/WorkersSayings'
//import CalculateDistance from '@/components/Company/CalculateDistance'

export default {
  components: {
    CompanyGooddies,
    //WorkersSayings,
    //CalculateDistance
  },

  props: {
    isMobile: {
      type: Boolean
    },
    benefits: {
      type: Array
    },
    CustomBenefit: {
      type: String
    },
    testimonials: {
      type: Array
    },
    companyName: {
      type: String
    }
  },

  data() {
    return {
      text: ' הטבות לעובדי '
    }
  },

  computed: {
    textForTitle() {
      return this.text + this.companyName 
    },

    displayTestimonials() {
      return isEmpty(this.testimonials) ? false : true
    },

    displayBenefits() {
      return isEmpty(this.benefits) ? false : true
    }
  },

  methods: {
    isEmptyArr(collection) {
      return isEmpty(collection) ? true : false
    }
  }
}
</script>

<style lang="scss" scoped>
#company-join-board {
  background-color: $bgGrayJob;
}

.mobile--calculator {
  position: relative;
}
.company-join-box {
  margin: 0 auto;
  max-width: 1260px;
  justify-content: space-between;
}
.icons-container {
  position: relative;
  bottom: 50px;
  left: 20px;
  .icon-big-ok {
    position: absolute;
    left: 30px;
  }
  .icon-star {
    position: absolute;
    top: 40px;
    left: 0;
  }
  .icon-ok {
    position: absolute;
    left: -8px;
  }
}

@media screen and (max-width: 600px) {
  .icons-container {
    bottom: 20px;
    left: 25px;
    .icon-big-ok {
      left: 7px;
      top: 12px;
      width: 30px;
    }
    .icon-star {
      top: 35px;
      left: -13px;
      width: 15px;
    }
    .icon-ok {
      top: 12px;
      left: -15px;
      width: 15px;
    }
  }
}

</style>
